module.exports = __webpack_public_path__ + "static/img/img.f7fb1118.jpg";